module.exports = __webpack_public_path__ + "mobile-background.ad3b7abf.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/components/HomePage/Header/images/mobile-background.jpg
// module id = 624
// module chunks = 0